export default "__VITE_ASSET__BV27Wqrz__ 640w, __VITE_ASSET__DpudL44w__ 768w, __VITE_ASSET__C9QRy0Qu__ 960w, __VITE_ASSET__C9yEap2p__ 1280w";